export function change_diary_date(diary_form) {
  if (window.history.pushState) {
    window.history.pushState({}, null, window.location.pathname + '?date=' + $(diary_form).find('input[name="date"]').val());
  }

  $(diary_form).trigger('submit');
}

export function pence_to_pounds(value){
  value = value / 100;
  return "£"+((Number(value)||0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1"));
}

export function stringGen(len) {
  var text = "";
  
  var charset = "abcdefghijklmnopqrstuvwxyz";
  
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  
  return text;
}